import {
    AfterViewInit,
    Component,
    Input,
    OnInit,
    OnChanges,
    SimpleChange,
    ViewChild,
    ElementRef,
    Output
} from '@angular/core';
import {PointOfSaleDto} from "../../point-of-sale-dto";
import {NotificationService} from "../../../../root/toast/notification.service";
import {CookieService} from "ngx-cookie";
import {GAService} from "../../../../root/ga/ga.service";


@Component({
    selector: 'cancun-instructions',
    templateUrl: './cancun-instructions.component.html',
    providers: []
})
export class CancunInstructionsComponent implements OnInit,AfterViewInit, OnChanges {

    @Input() errors;
    @Input() dto:PointOfSaleDto;
    @Output() childErrors;
    @Input() countryId;
    @Input() isValidLocation;

    errorSelectCounterLocation:boolean = false;
    MODAL_CANCUN_DELIVERY_INSTRUCTIONS = "modal_delivery_instructions";
    PHONE_PREFIX:string = "+52 ";
    FREE_LINE:string[] = [];
    GA_NOTIFY_CATEGORY = "Autos_CUN_Indications";
    cleanCheckCancun:boolean;

    constructor(private cookies: CookieService, private gaService: GAService) { }

    ngOnInit(): void {
        this.loadData();
        this.openModalCancunDeliveryIndications();
    }

    ngAfterViewInit(): void {
        this.loadTableCounters();
    }

    ngOnChanges(changes:  {[propKey: string]: SimpleChange}): void {
        const currentErrors = changes['errors'] ? changes['errors'].currentValue : undefined;
        const isValid = changes['isValidLocation'] ? changes['isValidLocation'].currentValue : undefined; //ver si es false en vez de undefined.
        this.errorSelectCounterLocation = currentErrors && currentErrors.positionsCounterRequired;

        if(isValid===false) {
            this.dto.pickupIndications.cancunAirportPositions = {
                hasCounter: false,
                counters: new Array()
            };
            this.cleanCheckCancun = false;
            let chkHasCounter = document.getElementById("chkHasCounter") as HTMLInputElement;
            if(chkHasCounter){
                chkHasCounter.checked = false;
            }
        }
    }

    loadTableCounters(){
        if(this.dto.pickupIndications.cancunAirportPositions && this.dto.pickupIndications.cancunAirportPositions.counters){
            this.dto.pickupIndications.cancunAirportPositions.counters.forEach(counter => {
                let chkCounter = document.getElementById("chkCounter" + counter.counter + counter.position) as HTMLInputElement;
                if(chkCounter){
                    chkCounter.checked = true;
                }
            });
        }
    }

    loadData(){
        if (this.dto.pickupIndications.cancunAirportPositions && this.dto.pickupIndications.cancunAirportPositions.hasCounter) {
            let chkHasCounter = document.getElementById("chkHasCounter") as HTMLInputElement;
            if(chkHasCounter){
                chkHasCounter.checked = this.dto.pickupIndications.cancunAirportPositions.hasCounter;
            }
        }
        else {
            this.dto.pickupIndications.cancunAirportPositions = {
                hasCounter: false,
                counters: new Array()
            };
            this.dto.pickupIndications.meetingType = "CALL";
        }
    }

    hasNotCounterInAirport():boolean {
        const chkHasCounter = document.getElementById("chkHasCounter") as HTMLInputElement;
        return !chkHasCounter.checked;
    }

    selectRadioHasCounter(checked:boolean) {
        this.errorSelectCounterLocation = false;

        if(checked){
            this.dto.pickupIndications.cancunAirportPositions.hasCounter = true;
            this.dto.pickupIndications.meetingType = "COUNTER";
            this.gaService.notify(this.GA_NOTIFY_CATEGORY, "counter", ["yes"]);
            this.loadTableCounters();
        }else{
            this.dto.pickupIndications.cancunAirportPositions.hasCounter = false;
            this.dto.pickupIndications.meetingType = "CALL";
            this.gaService.notify(this.GA_NOTIFY_CATEGORY, "counter", ["no"]);
        }

    }

    selectCounter(checked:boolean, counter:string, position:string) {
        this.errorSelectCounterLocation = false;
        this.cleanCheckCancun = undefined;
        const newCounter:any = {counter:counter, position:position};
        const counterFiltered = this.dto.pickupIndications.cancunAirportPositions.counters.filter(value=>value.counter == counter && value.position == position);

        if(!counterFiltered[0] && checked){
            this.dto.pickupIndications.cancunAirportPositions.counters.push(newCounter);

        }else if(counterFiltered[0] && !checked){
            const index = this.dto.pickupIndications.cancunAirportPositions.counters.indexOf(counterFiltered[0]);
            this.dto.pickupIndications.cancunAirportPositions.counters.splice(index, 1);
        }
        if (checked) this.gaService.notify(this.GA_NOTIFY_CATEGORY, "terminal_" + position.toLowerCase(), [counter]);
    }

    openModalCancunDeliveryIndications(){
        let modalCookie = this.cookies.get(this.MODAL_CANCUN_DELIVERY_INSTRUCTIONS);

        if (!modalCookie) {
            this.cookies.put(this.MODAL_CANCUN_DELIVERY_INSTRUCTIONS, '2');
            this.showModalCancunDeliveryIndications(true);

        }else if(parseInt(modalCookie) > 0){
            this.cookies.put(this.MODAL_CANCUN_DELIVERY_INSTRUCTIONS, (parseInt(modalCookie) - 1).toString());
            this.showModalCancunDeliveryIndications(true);
        }
    }

    closeModalCancunDeliveryIndications(gotIt: boolean) {
        this.gaService.notify(this.GA_NOTIFY_CATEGORY, "modal", [gotIt ? "confirm" : "close"]);

        if (gotIt) this.cookies.put(this.MODAL_CANCUN_DELIVERY_INSTRUCTIONS, '0');

        this.showModalCancunDeliveryIndications(false);
    }

    showModalCancunDeliveryIndications(val:boolean){
        let modal = document.getElementById("modalCancunDeliveryIndications");

        if(val){
            modal.classList.add("-show-modal")
        }else{
            modal.classList.remove("-show-modal");
        }
        return modal.className;
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/feature/pointOfSale/delivery-instructions/cancun-instructions/cancun-instructions.component.ts